import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useUserGroupFilter } from "../../../../TimeSheet/Team/Actions/useFilters/useUserGroupFilter";
import { useEmploymentTypeFilter } from "../../../../TimeSheet/Team/Actions/useFilters/useEmploymentTypeFilter";
import { useSalaryOrHourlyFilter } from "../../../../TimeSheet/Team/Actions/useFilters/useSalaryOrHourlyFilter";
import { usePeopleCustomFieldsFilters } from "../../../../TimeSheet/Team/Actions/useFilters/usePeopleCustomFieldsFilters";

export const useUserFilters = () => {
    const { t } = useTranslation();
    const userGroupFilter = useUserGroupFilter();
    const employmentTypeFilter = useEmploymentTypeFilter();
    const salaryOrHourlyFilter = useSalaryOrHourlyFilter();
    const peopleCustomFieldsFilters = usePeopleCustomFieldsFilters();

    return useMemo(() => ({
        userGroupFilter,
        employmentTypeFilter,
        salaryOrHourlyFilter,
        customFieldsFilters: peopleCustomFieldsFilters.map((filter: any) => ({
            ...filter,
            Header: filter.Header ?? t("custom-fields"),
        })),
    }), [userGroupFilter, employmentTypeFilter, salaryOrHourlyFilter, peopleCustomFieldsFilters, t]);
};
